export const mapFreightInsuranceResponseToRows = (data = {}) => {

  const rows = [
    {
      name: "Freight",
      currency: data.exportInvoiceFreightCurrency ?? "",
      exchangerate: data.exportInvoiceFreightExchangeRate ?? "",
      basevalue: data.exportInvoiceFreightBaseValue ?? 0,
    },
    {
      name: "Insurance",
      currency: data.exportInvoiceInsuranceCurrency ?? "",
      exchangerate: data.exportInvoiceInsuranceExchangeRate ?? "",
      basevalue: data.exportInvoiceInsuranceBaseValue ?? 0,
    },
    {
      name: "Discount",
      currency: data.exportInvoiceDiscountCurrency ?? "",
      exchangerate: data.exportInvoiceDiscountExchangeRate ?? "",
      rate: data.exportInvoiceDiscountRate ?? 0,
      basevalue: data.exportInvoiceDiscountBaseValue ?? 0,
      amount: data.exportInvoiceDiscountAmount ?? 0,
    },
    {
      name: "Other Deduction",
      currency: data.exportInvoiceOtherDeductionCurrency ?? "",
      exchangerate: data.exportInvoiceOtherDeductionExchangeRate ?? "",
      rate: data.exportInvoiceOtherDeductionRate ?? 0,
      basevalue: data.exportInvoiceOtherDeductionBaseValue ?? 0,
      amount: data.exportInvoiceOtherDeductionAmount ?? 0,
    },
    {
      name: "Commission",
      currency: data.exportInvoiceCommissionCurrency ?? "",
      exchangerate: data.exportInvoiceCommissionExchangeRate ?? "",
      rate: data.exportInvoiceCommissionRate ?? 0,
      basevalue: data.exportInvoiceCommissionBaseValue ?? 0,
      amount: data.exportInvoiceCommissionAmount ?? 0,
    },
    {
      name: "FOB Value",
      currency: data.exportInvoiceFOBValueCurrency ?? "",
      exchangerate: data.exportInvoiceFOBValueExchangeRate ?? 1,
    },
  ];

  return rows;
};


export const mapRowsToFreightInsuranceRequest = (rows = []) => {
  const safeNumber = (value) => isNaN(Number(value)) ? 0 : Number(value);

  const keyMap = [
    ["exportInvoiceFreightRate", "exportInvoiceFreightAmount"],
    ["exportInvoiceInsuranceRate", "exportInvoiceInsuranceAmount"],
    ["exportInvoiceDiscountRate", "exportInvoiceDiscountAmount"],
    ["exportInvoiceOtherDeductionRate", "exportInvoiceOtherDeductionAmount"],
    ["exportInvoiceCommissionRate", "exportInvoiceCommissionAmount"],
    ["exportInvoiceFOBValueRate", "exportInvoiceFOBValueAmount"],
  ];

  const payload = {};

  if (Array.isArray(rows)) {
    rows.forEach((row, index) => {
      if (keyMap[index]) {
        const [rateField, amountField] = keyMap[index];
        payload[rateField] = safeNumber(row?.rate);
        payload[amountField] = safeNumber(row?.amount);
      }
    });
  } else {
    // fallback if rows is an object with keys like "row-0"
    Object.entries(rows).forEach(([rowKey, rowValue]) => {
      const match = rowKey.match(/^row-(\d+)$/);
      if (match) {
        const index = Number(match[1]);
        if (keyMap[index]) {
          const [rateField, amountField] = keyMap[index];
          payload[rateField] = safeNumber(rowValue?.rate);
          payload[amountField] = safeNumber(rowValue?.amount);
        }
      }
    });
  }

  return payload;
};
